import { render, staticRenderFns } from "./_SidebarOnboarding.vue?vue&type=template&id=71caf6be&scoped=true"
import script from "./_SidebarOnboarding.vue?vue&type=script&lang=js"
export * from "./_SidebarOnboarding.vue?vue&type=script&lang=js"
import style0 from "./_SidebarOnboarding.vue?vue&type=style&index=0&id=71caf6be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71caf6be",
  null
  
)

export default component.exports